import { Pipe, PipeTransform } from '@angular/core';

const damageLevels = [
  { icf: 4, min: 96, max: 100, description: 'Volle Schädigung' }, // Schädigung voll ausgeprägt
  { icf: 3, min: 50, max: 95, description: 'Schwere Schädigung' }, // Schädigung erheblich ausgeprägt
  { icf: 2, min: 25, max: 49, description: 'Mäßige Schädigung' }, // Schädigung mäßig ausgeprägt
  { icf: 1, min: 5, max: 24, description: 'Leichte Schädigung' }, // Schädigung leicht ausgeprägt
  { icf: 0, min: 0, max: 4, description: 'Keine Schädigung' }, // Schädigung nicht vorhanden
];

@Pipe({
  name: 'icfDescription',
  standalone: true,
})
export class IcfDescriptionPipe implements PipeTransform {
  transform(value: number | null | undefined, zeile: 1 | 2): string {
    const data = damageLevels.find(level => level.icf === value);
    if (!data) {
      if (zeile === 1) {
        return 'Nicht ausgewählt';
      } else {
        return '';
      }
    }
    if (zeile === 1) {
      return `${data.description}`;
    } else {
      return `(${data.min} – ${data.max} %)`;
    }

    // return `${data.description} (${data.min}-${data.max} %)`;
  }

  getValueIcf(valuePercent: number): number {
    for (const level of damageLevels) {
      if (valuePercent >= level.min && valuePercent <= level.max) {
        return level.icf;
      }
    }
    return 4;
  }

  getDescriptionIcf(valuePercent: number): string {
    for (const level of damageLevels) {
      if (valuePercent >= level.min && valuePercent <= level.max) {
        return level.description;
      }
    }
    return damageLevels[0].description;
  }
  getDataIcf(valuePercent: number): { icf: number; min: number; max: number; description: string } {
    for (const level of damageLevels) {
      if (valuePercent >= level.min && valuePercent <= level.max) {
        return level;
      }
    }
    return damageLevels[0];
  }
}
